module.exports = __webpack_public_path__ + "static/media/button.13ea901d.svg";